export default __webpack_public_path__ + "static/media/img2.50e4915f.png";